export default {
  dialogueId: 'Dialogue id',
  readTheDialogueBeforeEvaluation: 'Read the dialogue before evaluating it',
  communicationQualitySurveyAnswerRules:
    '1 - Completely disagree, 12 - completely agree',
  survey: 'Survey'
};
